import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    templateUrl: './page-not-found.page.html',
    styleUrls: ['./page-not-found.page.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PageNotFoundPage {

    constructor() {
    }

}
